import { useEffect, useRef, useState } from "react";
import Buttons from "../../../../components/ui/button/Buttons";
import MolGrid from "../../../../components/Grid/MolGrid";
import { DecisionCardConfig } from "./DecisionCardCommitteeApprovalConfig";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../utils/Encryption";
import { useCorporateApplicationReadyForApprovalMutation, useLazyCorporateMembershipCommitteeApprovalListQuery, useLazyReadyForApprovalDetailsByCorporateMemberIdQuery,} from "../../../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import SwalAlert from "../../../../services/swalService/SwalService";
import { encryptAES } from "../../../../services/CryptoService";

const DecisionCardCommitteeApprovalForm = ({ tasklistId ,isViewOnly,isAppLocked, setInternalComment, internalComment }) => {
  const molGridRef = useRef();
  const { id } = useParams();
  const { error, success } = SwalAlert();
  const editID = id ? decryptAESID(id, false) : 0;
  const [dataSource, setDataSource] = useState([]);
  
  const [getApprovalList, { data: approvalListData, isLoading: listLoading }] = useLazyCorporateMembershipCommitteeApprovalListQuery();
  const [ getApprovalDetails, { data: approvalDetailsData, isLoading: detailsLoading }, ] = useLazyReadyForApprovalDetailsByCorporateMemberIdQuery();
  const [ sendForApproval, { data: approvalResponse, isLoading: approvalSending }, ] = useCorporateApplicationReadyForApprovalMutation();

  useEffect(() => {
    if (id && tasklistId) {
      getApprovalList({
        id: encryptAES(editID),
        id2: tasklistId,
      });
    }
  }, [id]);

  useEffect(() => {
     if (id && tasklistId) {
      getApprovalDetails({
        id: encryptAES(editID),
        id2: tasklistId,
      });
    }
   }, [editID, tasklistId]);

  useEffect(() => {
    if (approvalListData) {
      setDataSource(approvalListData);
    }
  }, [approvalListData]);

  useEffect(() => {
    if (approvalDetailsData?.internalComments !== undefined) {
      setInternalComment(approvalDetailsData.internalComments ?? "");
    }
  }, [approvalDetailsData]);

  useEffect(() => {
    if (!approvalSending && approvalResponse) {
      if (!approvalResponse.hasError) {
        success("Application sent for committee approval!");
      } else {
        error("Application already sent for approval");
      }
    }
  }, [approvalSending, approvalResponse]);

  // const handleSave = () => {
  //   sendForApproval({
  //     SGBCCorporateMemberId: editID,
  //     InternalComment: internalComment || null,
  //   });
  // };

  return (
    <div className="normal-card">
      <div className="internal-comments-section mt-4">
        <h6 className="section-title">Internal Comments (For SGBC only)</h6>
        <div className="text-area mb-3">
          <textarea
            className="text-area-input"
            placeholder="Enter internal comments"
            value={internalComment}
            onChange={(e) => setInternalComment(e.target.value)}
            disabled={isViewOnly}            
          />
        </div>
      </div>
      {/* <div className="btn-right-side">
        <Buttons
          buttonText="Ready for Approval"
          buttonTypeClassName="success-btn"
          onClick={handleSave}
          isLoading={approvalSending}
          isDisable={isViewOnly || isAppLocked}
        />
      </div> */}
      <h4 className="common-subtitle mt-4">Board Approval Status</h4>
      <div className="pricing-table-data decision-card-committee-approval-table">
        <MolGrid
          ref={molGridRef}
          configuration={DecisionCardConfig}
          dataSource={dataSource}
          allowPagination={false}
          isLoading={listLoading}
        />
      </div>
    </div>
  );
};

export default DecisionCardCommitteeApprovalForm;
